import { Suspense } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../firebase/auth-context';

/** App shell — sidebar navigation + content outlet. Shown only to admins. */
export default function Layout() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate('/login', { replace: true });
  };

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <div className="sidebar-header">
          <div className="brand">
            <svg width="20" height="20" viewBox="0 0 32 32" aria-hidden="true">
              <rect width="32" height="32" rx="6" fill="#1a56db" />
              <path
                d="M16 7 L16 25 M10 13 L16 7 L22 13"
                stroke="white"
                strokeWidth="2.5"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Lift Assisted
          </div>
          <div className="brand-sub">Admin Dashboard</div>
        </div>
        <nav className="sidebar-nav">
          <NavLink to="/" end className="nav-link">
            Overview
          </NavLink>
          <NavLink to="/activities" className="nav-link">
            Activities
          </NavLink>
          <NavLink to="/changes" className="nav-link">
            Changes
          </NavLink>
          <NavLink to="/reports" className="nav-link">
            Reports
          </NavLink>
          <NavLink to="/edits" className="nav-link">
            Edits
          </NavLink>
          <NavLink to="/users" className="nav-link">
            Users
          </NavLink>
          <NavLink to="/analytics" className="nav-link">
            Analytics
          </NavLink>
          <NavLink to="/exports" className="nav-link">
            Exports
          </NavLink>
          <NavLink to="/costs" className="nav-link">
            Costs
          </NavLink>
        </nav>
        <div className="sidebar-footer">
          <div className="user-email">{user?.email ?? '—'}</div>
          <button
            type="button"
            className="logout-btn"
            onClick={handleSignOut}
          >
            Sign out
          </button>
        </div>
      </aside>
      <main className="main-content">
        <Suspense
          fallback={<div className="spinner" aria-label="Loading" />}
        >
          <Outlet />
        </Suspense>
      </main>
    </div>
  );
}
